import type { WebsocketClient } from "../WebsocketClient";

export abstract class AWebsocketState {
  constructor(protected client: WebsocketClient) {}

  enter(): void {
    console.log(`${this.constructor.name}: entering`);
  }

  exit(): void {
    console.log(`${this.constructor.name}: exiting`);
  }

  connect(): void {
    console.log(`${this.constructor.name}: connect() not supported`);
  }

  disconnect(): void {
    console.log(`${this.constructor.name}: disconnect() not supported`);
  }

  send(message: string): void {
    this.client.enqueueOrSend(message);
  }

  sendJson(payload: unknown): void {
    try {
      const serialized = JSON.stringify(payload);
      this.client.enqueueOrSend(serialized);
    } catch (err) {
      console.error(`${this.constructor.name}: sendJson() failed to stringify payload`, err);
    }
  }

  onOpen(_ev: Event): void {}
  onMessage(_ev: MessageEvent): void {}
  onClose(_ev: CloseEvent): void {}
  onError(_ev: Event): void {}
}
